<template>
  <div class="horizontal" style="margin:10rem;">
    <div v-for="(note, index) in notes" :key="index" class="music-note" :class="{ 'jump': note.isPlaying }"></div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      notes: Array(5).fill({ isPlaying: false }),
    };
  },

  created() {
    this.jump(0)
  },
  methods: {
    jump(index) {
      if (index >= 5) return
      this.$set(this.notes, index, { isPlaying: true })
      var that = this
      setTimeout(() => {
        that.jump(index + 1)
      }, 100)
    }
  },
}
</script>
  
<style scoped>
.music-note {
  width: 3rem;
  height: 30rem;
  background-color: #3a7fb6;
  margin: 80rem 2rem 0 2rem;
}

.jump {
  animation: jumpAnimation 0.4s infinite alternate;
}

@keyframes jumpAnimation {
  to {
    transform: translateY(-20rem);
  }
}
</style>